import { render, staticRenderFns } from "./dashboardCardView.vue?vue&type=template&id=751db36c&scoped=true&"
import script from "./dashboardCardView.vue?vue&type=script&lang=js&"
export * from "./dashboardCardView.vue?vue&type=script&lang=js&"
import style0 from "./dashboardCardView.vue?vue&type=style&index=0&id=751db36c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751db36c",
  null
  
)

export default component.exports